/**
 * Networking Config Variables
 */
export default class NetworkConfig {
  /**
   * ALl possible environments for networking layer
   * @returns {Object}
   */
  static get Environments() {
    return {
      Dev: 'development',
      Recette: 'recette',
      Prod: 'production',
    };
  }

  /**
   * Current Environment identifier
   * @returns {string}
   */
  static get currentEnvironment() {
    return process.env.NODE_ENV;
  }

  /**
   * Bool value indicating wathever the log for requests is enabled
   * @return {Boolean} true if we need to print the logs in console
   */
  static get isLogEnabled() {
    switch (NetworkConfig.currentEnvironment) {
      case NetworkConfig.Environments.Dev:
        return true;
      case NetworkConfig.Environments.Recette:
        return false;
      case NetworkConfig.Environments.Prod:
      default:
        return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/network/network-config.js